import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RightSidePopupComponent } from './right-side-popup/right-side-popup.component';
import { RouterModule } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalPopupComponent } from './modal-popup/modal-popup.component';


@NgModule({
  declarations: [
    RightSidePopupComponent,
    ModalPopupComponent
  ],
  imports: [
    NgbModule,
    CommonModule,
    // BrowserAnimationsModule,
    RouterModule
  ],
  exports: [
    RightSidePopupComponent,
    ModalPopupComponent
  ],
  providers: [
    Location
  ]
})
export class CommonsModule { }
